//General
import React, { useContext, useState, useEffect } from "react";
//Styles
import { Modal, Tabs, Tab } from "react-bootstrap";
import { Autocomplete, TextField } from "@mui/material";
import { Formik, Form } from "formik";
//Context
import { ServiceContext } from "../../data/services/ServiceContext";
import { CustomerContext } from "../../data/customer/CustomerContext";
//Redux
import { useSelector, useDispatch } from "react-redux";
//Actions
import { getCities, getDistricts } from "../../data/general/LocationSlice";
//Components
import CapitalizedFormikField from "../../components/CapitalizedFormikField";
//Page
import ServisActionPage from "../../page/ServiceActionPage";
import ServiceActionAddModal from "../action/service/ServiceActionAddModal";
import ServiceActionUpdateModal from "../action/service/ServiceActionUpdateModal";

//Fonksiyonlar

function ServiceUpdateModal({ show, handleClose, service }) {
  const { updateService } = useContext(ServiceContext);
  const { customers, updateCustomer } = useContext(CustomerContext);
  const dispatch = useDispatch();
  const { cities, districts } = useSelector((state) => state.location);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);


  const customer = customers.find((c) => c.id === service?.customerId);
  const [customerType, setCustomerType] = useState(
    customer?.customerType?.toLowerCase() || "bireysel"
  );
  const [searchedCity, setSearchedCity] = useState(customer?.city || "");

  useEffect(() => {
    dispatch(getCities());
  }, [dispatch]);

  useEffect(() => {
    if (searchedCity) dispatch(getDistricts({ city: searchedCity }));
  }, [searchedCity, dispatch]);

  useEffect(() => {
    if (customer) {
      setCustomerType(customer.customerType?.toLowerCase() || "bireysel");
      setSearchedCity(customer.city || "");
    }
  }, [customer]);

  if (!service) return null;

  const initialValues = {
    fullName: customer?.fullName || "",
    phone1: customer?.phone1 || "",
    phone2: customer?.phone2 || "",
    customerType: customerType,
    tcNo: customer?.tcNo || "",
    vergiNo: customer?.vergiNo || "",
    vergiDairesi: customer?.vergiDairesi || "",
    city: customer?.city || "",
    district: customer?.district || "",
    address: customer?.address || "",
    brand: service?.brand || "",
    device: service?.device || "",
    deviceModel: service?.deviceModel || "",
    issue: service?.issue || "",
    note: service?.note || "",
    warranty: service?.warranty || "var",
    availableDate: service?.availableDate || "",
    availableStart: service?.availableStart || "",
    availableEnd: service?.availableEnd || "",
    urgency: service?.urgency || false,
    phone3: service?.phone3 || "",
  };
  //HTML
  return (
    <Modal show={show} onHide={handleClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Servis Güncelle</Modal.Title>
      </Modal.Header>

      <Tabs defaultActiveKey="info" id="service-tabs" className="mb-3 mt-3">
        {/* 🔹 Servis / Müşteri Bilgileri Tabı */}
        <Tab eventKey="info" title="Servis Bilgileri">
          <Formik
            enableReinitialize
            initialValues={initialValues}
            onSubmit={(values) => {
              if (customer) {
                updateCustomer(service.customerId, {
                  fullName: values.fullName,
                  phone1: values.phone1,
                  phone2: values.phone2,
                  customerType: values.customerType,
                  tcNo: values.tcNo,
                  vergiNo: values.vergiNo,
                  vergiDairesi: values.vergiDairesi,
                  city: values.city,
                  district: values.district,
                  address: values.address,
                });
              }
              updateService(service.id, {
                brand: values.brand,
                device: values.device,
                deviceModel: values.deviceModel,
                issue: values.issue,
                note: values.note,
                warranty: values.warranty,
                availableDate: values.availableDate,
                availableStart: values.availableStart,
                availableEnd: values.availableEnd,
                urgency: values.urgency,
                phone3: values.phone3,
              });
              handleClose();
            }}
          >
            {({ values, handleChange, setFieldValue }) => (
              <Form className="p-3">
                <div className="d-flex flex-column flex-lg-row gap-4">
                  {/* Sol sütun */}
                  <div
                    className="flex-fill p-3"
                    style={{
                      border: "1px solid rgba(0,0,0,0.1)",
                      borderRadius: "8px",
                     
                    }}
                  >
                    <h5>Müşteri Bilgileri</h5>
                    <CapitalizedFormikField
                      name="fullName"
                      label="Müşteri Adı Soyadı"
                      size="small"
                      fullWidth
                      className="my-2"
                    />
                    <CapitalizedFormikField
                      name="phone1"
                      label="Telefon 1"
                      size="small"
                      fullWidth
                      className="my-2"
                    />
                    <CapitalizedFormikField
                      name="phone2"
                      label="Telefon 2"
                      size="small"
                      fullWidth
                      className="my-2"
                    />

                    <div className="my-2">
                      <label className="form-label">Müşteri Türü</label>
                      <select
                        name="customerType"
                        className="form-select"
                        value={customerType}
                        onChange={(e) => {
                          setCustomerType(e.target.value);
                          setFieldValue("customerType", e.target.value);
                        }}
                      >
                        <option value="bireysel">Bireysel</option>
                        <option value="kurumsal">Kurumsal</option>
                      </select>
                    </div>

                    {customerType === "bireysel" ? (
                      <CapitalizedFormikField
                        name="tcNo"
                        label="T.C. Kimlik No"
                        size="small"
                        fullWidth
                        className="my-2"
                      />
                    ) : (
                      <div className="row my-2">
                        <div className="col">
                          <CapitalizedFormikField
                            name="vergiNo"
                            label="Vergi No"
                            size="small"
                            className="my-2"
                            fullWidth
                          />
                        </div>
                        <div className="col">
                          <CapitalizedFormikField
                            name="vergiDairesi"
                            label="Vergi Dairesi"
                            size="small"
                            fullWidth
                            className="my-2"
                          />
                        </div>
                      </div>
                    )}

                    {/* Şehir / İlçe */}
                    <div className="row my-2">
                      <div className="col">
                        <Autocomplete
                          options={cities || []}
                          value={values.city || ""}
                          onChange={(e, newValue) => {
                            setFieldValue("city", newValue || "");
                            setFieldValue("district", "");
                            if (newValue) setSearchedCity(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Şehir"
                              size="small"
                              fullWidth
                            />
                          )}
                          disablePortal
                          autoHighlight
                        />
                      </div>
                      <div className="col">
                        <Autocomplete
                          options={districts || []}
                          value={values.district || ""}
                          onChange={(e, newValue) =>
                            setFieldValue("district", newValue || "")
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="İlçe"
                              size="small"
                              fullWidth
                            />
                          )}
                          disablePortal
                          autoHighlight
                          disabled={!values.city}
                        />
                      </div>
                    </div>

                    <CapitalizedFormikField
                      name="address"
                      label="Adres"
                      size="small"
                      fullWidth
                      multiline
                      rows={3}
                      className="my-2"
                    />
                  </div>

                  {/* Sağ Sütun */}
                  <div
                    className="flex-fill p-3"
                    style={{
                      border: "1px solid rgba(0,0,0,0.1)",
                      borderRadius: "8px",
                     
                    }}
                  >
                    <h5>Ürün / Cihaz Bilgileri</h5>
                    <div className="row my-2 mt-3">
                      <div className="col">
                        <CapitalizedFormikField
                          name="brand"
                          label="Marka"
                          size="small"
                          fullWidth
                        />
                      </div>
                      <div className="col">
                        <CapitalizedFormikField
                          name="device"
                          label="Cihaz"
                          size="small"
                          fullWidth
                        />
                      </div>
                    </div>
                    <CapitalizedFormikField
                      name="deviceModel"
                      label="Model"
                      size="small"
                      fullWidth
                      className="my-2"
                    />
                    <CapitalizedFormikField
                      name="issue"
                      label="Arıza Notu"
                      size="small"
                      fullWidth
                      multiline
                      rows={3}
                      className="my-2"
                    />
                    <CapitalizedFormikField
                      name="note"
                      label="Ek Not"
                      size="small"
                      fullWidth
                      multiline
                      rows={3}
                      className="my-2"
                    />

                    <div className="my-2">
                      <label className="form-label">Garanti Durumu</label>
                      <select
                        name="warranty"
                        className="form-select"
                        value={values.warranty}
                        onChange={handleChange}
                      >
                        <option value="var">Var</option>
                        <option value="yok">Yok</option>
                      </select>
                    </div>

                    <div className="row mt-4">
                      <div className="col-12 col-md-4 mb-3 mb-md-0">
                        <CapitalizedFormikField
                          type="date"
                          name="availableDate"
                          label="Tarih"
                          variant="outlined"
                          size="small"
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                        />
                      </div>
                      <div className="col-12 col-md-8 d-flex flex-column flex-md-row gap-2">
                        <CapitalizedFormikField
                          type="time"
                          name="availableStart"
                          label="Başlangıç Saati"
                          variant="outlined"
                          size="small"
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                        />

                        <CapitalizedFormikField
                          type="time"
                          name="availableEnd"
                          label="Bitiş Saati"
                          variant="outlined"
                          size="small"
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Form Footer */}
                <div className="d-flex justify-content-end gap-2 mt-3">
                  <button type="submit" className="btn btn-primary">
                    Güncelle
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleClose}
                  >
                    İptal
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </Tab>

        {/* 🔹 Atanan Aksiyonlar Tabı */}
        <Tab eventKey="actions" title="Atanan Aksiyonlar">
          <div className="p-3 mt-2">
            <ServisActionPage
              serviceId={service.id}
              onAdd={() => setShowAddModal(true)}
              onEdit={(action) => {
                setSelectedService(action);
                setShowUpdateModal(true);
              }}
              onDelete={(actionId) => {

                console.log("Silinecek aksiyon ID:", actionId);
              }}
            />
            <ServiceActionAddModal
              show={showAddModal}
              handleClose={() => setShowAddModal(false)}
              serviceId={service.id}
            />
            <ServiceActionUpdateModal
              show={showUpdateModal}
              handleClose={() => setShowUpdateModal(false)}
              action={selectedService}
            />

          </div>
        </Tab>

      </Tabs>
    </Modal>
  );
}

export default ServiceUpdateModal;
